module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae.03aa14c21a8f584d81b53ca9d5c56fb8.webp";